import { createAsyncAction } from 'typesafe-actions';
import { ReviewsPhotosPaginationProps, ReviewsPhotosResponse } from '../types/fetch-models';

export const FETCH_REVIEWS_PHOTOS_PAGE = createAsyncAction(
  'reviews-photos/FETCH_REVIEWS_PHOTOS_PAGE/request',
  'reviews-photos/FETCH_REVIEWS_PHOTOS_PAGE/success',
  'reviews-photos/FETCH_REVIEWS_PHOTOS_PAGE/failure',
  'reviews-photos/FETCH_REVIEWS_PHOTOS_PAGE/cancel',
)<ReviewsPhotosPaginationProps, ReviewsPhotosResponse, Error, void>();
